export default function headerBehaviour() {
  const header = document.querySelector('.site-header');
  const bodyWidth = document.body.offsetWidth;

  if (bodyWidth >= 1024) {
    if (document.body.scrollTop >= 30 || document.documentElement.scrollTop >= 30) {
      header.classList.add('header-fixed');
    } else {
      header.classList.remove('header-fixed');
    }
  } else {
    if (document.body.scrollTop >= 30 || document.documentElement.scrollTop >= 30) {
      header.classList.add('header-fixed');
    } else {
      header.classList.remove('header-fixed');
    }
  }
}
